import React, { useContext } from 'react'
import { StockContext } from '../../Context/StockContext'
import CardProps from '../CardProps/CardProps'
import Bull_market_logo from '../../../Assets/Bull-Market-logo 2.jpg'
import Arrow_Up from '../../../Assets/UpwardArrow.png'
import 'bootstrap/dist/css/bootstrap.min.css';
import './HigherStockPrice.css'

const HigherStockPrice = () => {

  const {PositivePriceStocks, StockGraphList} = useContext(StockContext)

  console.log(PositivePriceStocks)

  return (
    <section className='HigherStockPrice-container p-2'>
      {PositivePriceStocks === null || PositivePriceStocks === undefined ?
      (<div className="spinner-border text-danger" role="status"></div>)
    
      : PositivePriceStocks.length === 0 ? (<div><p>No Stocks with higher percentage difference available</p></div>)
    
      :
    
    PositivePriceStocks.map((item, index) => {
      return(<CardProps key={index} index={index} market_logo={Bull_market_logo}
        Stock_Name={item.company_name} price={item.latest_date_price} Arrow={Arrow_Up}
        percentage_difference={item.stock_price_difference} textColor='green' from_date={item.from_date} to_date={item.to_date}
        />)
    })
      }
    </section>
  )
}

export default HigherStockPrice
